import { render, staticRenderFns } from "./quickFees.vue?vue&type=template&id=0342d036&scoped=true"
import script from "./quickFees.vue?vue&type=script&lang=js"
export * from "./quickFees.vue?vue&type=script&lang=js"
import style0 from "./quickFees.vue?vue&type=style&index=0&id=0342d036&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342d036",
  null
  
)

export default component.exports